import './Breadcrumbs.scss';

import { PROJECTS, QUESTIONS } from '../../routes/path';
import { t } from 'i18next';
import { useAccount } from '../../contexts/account/AccountContexts';
import React from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  name: string;
  /** Bez adresu okruszek jest zwykłym tekstem (bieżące miejsce). */
  href?: string;
}

interface BreadcrumbsProps {
  /**
   * Jawny trail dla stron, których ścieżka nie opisuje hierarchii — np. raport żyje pod
   * `/reports/:projectId/:reportId`, ale należy do projektu, więc prowadzi do niego przez „Projects”,
   * a nie przez segment „reports”. Podany, wyłącza odczyt z URL-a w całości.
   */
  items?: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const { projectResponse } = useAccount();

  const path = window.location.pathname;
  const parts = path.split('/').filter(Boolean);

  const getName = (pathPart: string, idx: number) => {
    const id = Number(pathPart);
    if (isNaN(id)) {
      switch (`/${pathPart}`) {
        case PROJECTS:
          return t('projects');

        case QUESTIONS:
          return t('promptsQuestions');

        default:
          return '';
      }
    }

    const previousPart = parts[idx - 1];
    switch (`/${previousPart}`) {
      case PROJECTS:
        const selectedProject = projectResponse?.find((project) => project.id === id);
        const projectLabel = selectedProject?.projectLabel;
        return projectLabel || '';

      default:
        return '';
    }
  };

  const visibleParts = parts
    .map((part, idx) => {
      const name = getName(part, idx) || '';
      return { part, idx, name: name.trim() };
    })
    .filter((item) => item.name !== '');

  if (items) {
    return (
      <nav className="breadcrumbs">
        <ul>
          {items.map(({ name, href }, i) => (
            <li key={href ?? `crumb-${i}`}>{href ? <Link to={href}>{name}</Link> : <span>{name}</span>}</li>
          ))}
        </ul>
      </nav>
    );
  }

  if (visibleParts.length === 0) {
    return null;
  }

  return (
    <nav className="breadcrumbs">
      <ul>
        {visibleParts.map(({ idx, name }, i) => {
          const href = '/' + parts.slice(0, idx + 1).join('/');
          const visiblePartsCount = visibleParts.length;
          const isLast = i === visiblePartsCount - 1 && visiblePartsCount > 1;

          // `Link`, nie `<a href>` — przejście w aplikacji bez przeładowania całej strony.
          return <li key={href}>{isLast ? <span>{name}</span> : <Link to={href}>{name}</Link>}</li>;
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
